export default __webpack_public_path__ + "static/media/remove-inactive.43026d2c.svg";